var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "spreadsheet",
        {
          ref: "spreadsheet",
          staticClass: "spreadsheet-container",
          attrs: {
            "use-culture-decimals": false,
            sheetsbar: false,
            toolbar: false,
            columns: _vm.columns.length + 1,
            rows: _vm.series.length + 1,
            "column-width": 150,
            "row-height": 25,
          },
          on: { change: _vm.onChange },
        },
        [_c("spreadsheet-sheet", { attrs: { name: _vm.title } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }